import {
    loadCarouselHandlers
} from './modules/Carousel'

import {
    loadNavBarHandlers
} from './modules/navBar'

import {
    loadHondaHandlers
} from './modules/Honda'

import {
    loadLineHandlers
} from './modules/Line'

import {
    loadSearchHandlers
} from './modules/Search'

import {
    loadToggleHanlders
} from './modules/Toggle'





window.addEventListener('DOMContentLoaded', ()=>{

    loadCarouselHandlers();

    loadSearchHandlers();

    loadToggleHanlders();

});

window.addEventListener("load", ()=>{

    loadNavBarHandlers();

    loadHondaHandlers();

    loadLineHandlers();

    $(document).on("submit", "#formSearch", function (e) {
        e.preventDefault();
        if ($(this).find(".textSearch").val() != "") {
            document.location.href = "/Buscar?q=" + $(this).find(".textSearch").val();
        } else {
            $(this).find(".textSearch").css("border-style", "solid");
            $(this).find(".textSearch").css("border-color", "rgb(218, 16, 16)");
            $(this).find(".textSearch").css("border-width", "0px 0px 1px");
            $(this).find(".textSearch").focus();
        }
    });

});